import { styled } from '@material-ui/core'
import { Button as BaseButton } from 'shared/components'

export const Button = styled(BaseButton)(({ theme }) => ({
  width: 'max-content',
  padding: theme.spacing(0.6, 1),
  margin: theme.spacing(0.8),
  fontWeight: 600,
  fontSize: 16,
}))
